/** Walidatory pól firmowych (NIP, kod pocztowy) — wspólne dla formularzy integratora i klienta. */

/** Suma kontrolna NIP-u (wagi 6,5,7,2,3,4,5,6,7). Dopuszcza myślniki/spacje. */
const NIP_WEIGHTS = [6, 5, 7, 2, 3, 4, 5, 6, 7];

/** Zwraca same cyfry NIP-u (usuwa myślniki i spacje) — do zapisu w payloadzie. */
export const nipDigits = (raw: string): string => raw.replace(/[\s-]/g, '');

export const isValidNip = (raw: string): boolean => {
  const d = nipDigits(raw);
  if (!/^\d{10}$/.test(d)) return false;
  const check = NIP_WEIGHTS.reduce((acc, w, i) => acc + w * Number(d[i]), 0) % 11;
  return check !== 10 && check === Number(d[9]);
};

/** Polski kod pocztowy w formacie XX-XXX. */
export const isValidPostCode = (raw: string): boolean => /^\d{2}-\d{3}$/.test(raw.trim());

/** Pragmatyczna walidacja formatu e-maila (nie pełen RFC — coś@coś.tld bez spacji). */
export const isValidEmail = (raw: string): boolean => /^\S+@\S+\.\S+$/.test(raw.trim());
